<template>
    <!-- В body: стекло SidePanel (backdrop-filter) иначе становится containing block для fixed
         и вложенный диалог (копирование, удаление вакансии) оказывается внутри панели. -->
    <Teleport to="body">
        <div class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-[70]">
            <div class="ds-glass-scrim" @click="closeModal"></div>

            <div class="ds-glass-dialog">
                <slot></slot>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">

const emit = defineEmits(["close"]);

function closeModal() {
    emit('close')
}
</script>
